module.exports = __webpack_public_path__ + "img/icon-fancoil.4c6f40ef.svg";